import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import OffersPage from "@/pages/OffersPage";
import OfferDetailPage from "@/pages/OfferDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BuildPackagePage from "@/pages/BuildPackagePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSlidesPage from "@/pages/AdminSlidesPage";
import AdminOffersPage from "@/pages/AdminOffersPage";
import AdminContactsPage from "@/pages/AdminContactsPage";
import AdminAuditPage from "@/pages/AdminAuditPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import LegacyRedirect from "@/components/LegacyRedirect";

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrandProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/offers" element={<OffersPage />} />
                <Route path="/offers/:id" element={<OfferDetailPage />} />
                <Route path="/build-package" element={<BuildPackagePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />

                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="slides" element={<AdminSlidesPage />} />
                  <Route path="offers" element={<AdminOffersPage />} />
                  <Route path="contacts" element={<AdminContactsPage />} />
                  <Route path="audit" element={<AdminAuditPage />} />
                  <Route path="users" element={<AdminUsersPage />} />
                </Route>

                {/* Legacy WordPress URL redirects (301-ish for SEO via meta refresh + canonical) */}
                <Route path="/wp-admin/*" element={<LegacyRedirect />} />
                <Route path="/wp-admin" element={<LegacyRedirect />} />
                <Route path="/wp-login.php" element={<LegacyRedirect />} />
                <Route path="/xmlrpc.php" element={<LegacyRedirect />} />
                <Route path="/wp-content/*" element={<LegacyRedirect />} />
                <Route path="/wp-includes/*" element={<LegacyRedirect />} />
                <Route path="/wp-json/*" element={<LegacyRedirect />} />
                <Route path="/feed" element={<LegacyRedirect />} />
                <Route path="/rss" element={<LegacyRedirect />} />
                <Route path="/rss2" element={<LegacyRedirect />} />
                <Route path="/comments/feed" element={<LegacyRedirect />} />
                <Route path="/author/*" element={<LegacyRedirect />} />
                <Route path="/category/*" element={<LegacyRedirect />} />
                <Route path="/tag/*" element={<LegacyRedirect />} />
                {/* Catch-all: any unmatched path falls back to home */}
                <Route path="*" element={<LegacyRedirect />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </BrandProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
